<script lang="ts">
	import { Accordion } from '@skeletonlabs/skeleton-svelte';
	import Fa from 'svelte-fa';
	import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
	import Section from '$lib/shared/ui/Section.svelte';
	import SectionHeading from '$lib/shared/ui/SectionHeading.svelte';
	import Reveal from '$lib/shared/ui/Reveal.svelte';

	const items = [
		{
			value: 'what',
			q: 'What is Supertip.gg',
			a: 'Supertip is the ultimate toolkit for live shows who want to engage their audience like never before. With features like AI voice conversations, animated characters, custom overlays, and interactive surveys and triggers, Supertip helps you create dynamic, personalized shows that keep viewers coming back.'
		},
		{
			value: 'equipment',
			q: 'Do I need any special equipment or software?',
			a: "Nope! You don't need any special gear or software to use Supertip. Just a basic streaming setup (microphone, camera, streaming platform) and you're good to go. Supertip was built to be plug-and-play, with no extra downloads or hardware required."
		},
		{
			value: 'beginner',
			q: "Can I Supertip if I'm new to streaming?",
			a: "Absolutely! Supertip is designed with beginners in mind. It's user-friendly and integrates smoothly with any standard streaming setup. Whether you're just starting out or have years of experience, Supertip enhances your show without any learning curve."
		},
		{
			value: 'engage',
			q: 'How does Supertip help me engage my audience?',
			a: 'Supertip gives you hands-on tools to boost audience interaction, like real-time polls, voice tips where fans can leave recorded messages, and custom alerts that celebrate key moments. These features make your show feel more interactive and personal, helping you connect with your viewers in meaningful ways.'
		},
		{
			value: 'price',
			q: 'Is Supertip free to use?',
			a: 'Yes! Supertip is completely free. There are no subscription fees or hidden charges. You get full access to all features without needing to pay anything.'
		}
	];

	let expandedValue: string[] = ['what'];
</script>

<Section id="faq">
	<div class="grid w-full grid-cols-1 gap-10 md:grid-cols-2 md:gap-16">
		<Reveal class="w-full">
			<div class="md:sticky md:top-28">
				<SectionHeading
					align="left"
					title="Frequently Asked Questions"
					titleClass="text-3xl font-extrabold tracking-tight text-balance text-surface-950-50 sm:text-4xl"
				>
					Everything you need to know about Supertip. Need more help? Reach out at <a
						href="mailto:info@supertip.gg"
						class="font-semibold text-primary-500 underline">info@supertip.gg</a
					> anytime.
				</SectionHeading>
			</div>
		</Reveal>

		<Reveal delay={120} class="w-full">
			<Accordion
				value={expandedValue}
				onValueChange={(d) => (expandedValue = d.value)}
				multiple={false}
				collapsible
				class="space-y-3"
			>
				{#each items as item (item.value)}
					{@const isOpen = expandedValue.includes(item.value)}
					<Accordion.Item
						value={item.value}
						class="rounded-2xl border transition-colors {isOpen
							? 'border-primary-500/50 bg-primary-500/5'
							: 'border-surface-200/55 bg-surface-50 hover:border-primary-500/40 dark:border-surface-700/60 dark:bg-surface-900 dark:hover:border-surface-600'}"
					>
						<Accordion.ItemTrigger
							class="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
						>
							<span class="text-base font-semibold text-surface-950-50">{item.q}</span>
							<Fa
								icon={faChevronDown}
								class="shrink-0 text-primary-500 transition-transform duration-200 {isOpen
									? 'rotate-180'
									: ''}"
							/>
						</Accordion.ItemTrigger>
						<Accordion.ItemContent class="px-5 pt-0 pb-4 text-sm text-surface-800-200">
							<p>{item.a}</p>
						</Accordion.ItemContent>
					</Accordion.Item>
				{/each}
			</Accordion>
		</Reveal>
	</div>
</Section>
